import './SuccessForm.scss';
import './SuccessForm-media.scss';
import { SvgTg, SvgVk } from '../Header/MenuPopupTeam/constants';
import { LinkTg, LinkVk } from '../../services/content/Constants';
import {content} from "../../services/content";

const SuccessForm = ({ refCss, closed }: { refCss?: any; closed: any }) => {
  return (
    <div ref={refCss} className="success-form">
      <div className="success-form__success">
        <div className="success-form__close" onClick={closed}></div>
        <h2 className="success-form__success-text">{content.modalForm.successText}</h2>
        <p className="body1">{content.modalForm.successText2}</p>
        <div className="success-form__socs">
          <a href={LinkTg} target="_blank" className="success-form__soc" rel="nofollow">
            {SvgTg}
          </a>
          <a href={LinkVk} className="success-form__soc" target="_blank" rel="nofollow">
            {SvgVk}
          </a>
        </div>
      </div>
    </div>
  );
};

export default SuccessForm;
